module.exports = __webpack_public_path__ + "img/9.901b0a10.jpg";